import { defineMessages } from 'react-intl'

export default defineMessages({
  addTime: {
    id: 'InputDateTime.AddTime',
    defaultMessage: 'Add a time'
  }
})
